import { useFlagsStatus } from '@unleash/proxy-client-react';
import { Trans, useTranslation } from 'react-i18next';

import { useAuth } from '@furality/frontend-stack';
import { CardLayout } from '@/components/layouts/index.tsx';
import Overlapping from '@/components/Overlapping.tsx';
import Placeholder from '@/components/Placeholder.tsx';
import { DISCORD_INVITE_URL } from '@/lib/constants.ts';

const Maintenance = () => {
  const { t } = useTranslation();
  const ready = useFlagsStatus().flagsReady;
  const auth = useAuth();

  return (
    <CardLayout title="shared.navigation.maintenance">
      <Overlapping>
        <img
          alt="Furality logo"
          src="https://media.cdn.furality.online/image/logo/fox-logo.svg"
          className="img-fluid d-block mx-auto mt-5"
          style={{ maxWidth: '25em' }}
        />
        <div className="position-relative w-100">
          <button
            type="button"
            style={{
              width: '2.25em',
              height: '1em',
              bottom: '20%',
              left: '50%',
              opacity: 0,
              transform: 'translateX(-50%)',
            }}
            className="position-absolute"
            onClick={() => auth.login()}
            aria-hidden="true"
            tabIndex={-1}
          >
            <span className="sr-only">{t('shared.sign_in.screen_reader')}</span>
          </button>
        </div>
      </Overlapping>
      <div className="mt-5 mb-5 text-center">
        {ready && (
          <Trans
            i18nKey="shared.maintenance.content"
            components={{
              h: <h1 className="h2" />,
              p: <p className="lead" />,
              linkDiscord: <a href={DISCORD_INVITE_URL} />,
            }}
          />
        )}
        {!ready && <Placeholder width="4em" />}
      </div>
    </CardLayout>
  );
};

export default Maintenance;
